/**
 * User roles supported in the system.
 *
 * Each role is mirrored by a sara knowledge-graph node `ROLE-*`:
 *   [[ROLE-DRIVER]], [[ROLE-GUARD]], [[ROLE-MECHANIC]], [[ROLE-VIEWER]],
 *   [[ROLE-DISPATCHER]], [[ROLE-SENIOR-DISPATCHER]], [[ROLE-ADMIN]],
 *   [[ROLE-SUPER-ADMIN]], [[ROLE-ERP]].
 *
 * Source of truth on the backend: `Symfony Security` role configuration.
 */
export type UserRole =
    | 'ROLE_DRIVER'
    | 'ROLE_GUARD'
    | 'ROLE_MECHANIC'
    | 'ROLE_VIEWER'
    | 'ROLE_DISPATCHER'
    | 'ROLE_SENIOR_DISPATCHER'
    | 'ROLE_ADMIN'
    | 'ROLE_SUPER_ADMIN'
    | 'ROLE_ERP'

export const USER_ROLE_OPTIONS: Array<{ value: UserRole; label: string }> = [
    { value: 'ROLE_DRIVER', label: 'Водій' },
    { value: 'ROLE_GUARD', label: 'Охоронець' },
    { value: 'ROLE_MECHANIC', label: 'Механік' },
    { value: 'ROLE_VIEWER', label: 'Переглядач' },
    { value: 'ROLE_DISPATCHER', label: 'Диспетчер' },
    { value: 'ROLE_SENIOR_DISPATCHER', label: 'Старший диспетчер' },
    { value: 'ROLE_ADMIN', label: 'Адмін' },
    { value: 'ROLE_SUPER_ADMIN', label: 'Супер Адмін' },
    { value: 'ROLE_ERP', label: 'ERP-інтеграція' },
]
